<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!--  사업장 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 사업장 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>작업내용</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <ml-input v-else v-model="form.inputB_1" :readonly="board.readonly" />
        </div>
        <div>
          <div>조사일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <date-selector v-else v-model="form.inputB_5" :readonly="board.readonly" />
        </div>

        <div>
          <div>작업자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input v-else v-model="form.inputB_4" :readonly="board.readonly" />
        </div>
        <div>
          <div>수행일시</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <date-selector v-else v-model="form.inputB_2" :readonly="board.readonly" />
        </div>
        <div>
          <div>확인자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <ml-input v-else v-model="form.inputB_3" :readonly="board.readonly" />
        </div>
        <div>
          <div>점검장소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
          <ml-input v-else v-model="form.inputB_6" :readonly="board.readonly" />
        </div>

        <div>
          <div>재해형태(필수)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_7 }}</p>
          <disaster-class-selector v-else v-model="form.inputB_7" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <TableInspectMerge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="유해·위험요인 조사표"
      tableHeaderTitle="항목 및 내용"
      :tableHeaderCheck="[{ text: '작성' }, { text: '미작성' }, { text: '해당없음' }]"
      :tableHeaderNote="[{ text: '비고' }]"
      v-model="form.inspectList_1"
      class="mt-28px"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader.vue";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          안전보건자료_사업장명: [],
        };

        value.summary["안전보건자료_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",

        fileList: [],
        inspectList_1: [
          {
            content: "사고나 질병이 발생했던 업무에 관하여 재해발생 보고서 작성 여부",
            isChecked: "",
          },
          {
            content: "유해 · 위험한 작업이 있는 설비 또는 업무에 대하여 안전점검 실시 여부",
            isChecked: "",
          },
          {
            content: "허용기준을 초과한 부서의 작업환경측정 여부",
            isChecked: "",
          },
          {
            content: "유소견자가 근무하는 작업자에 관한 건강진단 여부",
            isChecked: "",
          },
          {
            content: "산업안전보건위원회에서 논의된 업무의 산업안전보건위원회 회의록 작성 여부",
            isChecked: "",
          },
          {
            content: "건강관리실 이용자가 많은 작업에 관한 안전보건활동기록지 작성 여부",
            isChecked: "",
          },
          {
            content: "근골격계 유해요인 조사에서 나타난 부담작업에 관한 기타 자료 작성 여부",
            isChecked: "",
          },
        ],
      },
    };
  },
};
</script>
